import React from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
} from "react-bootstrap";
import Swal from "sweetalert2";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { tambahTargetKorwil } from "stores";
import { getAllKorwil } from "stores";
import { getAllClient } from "stores";
import CurrencyInput from "react-currency-input-field";

function InputTargetKorwil() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.authReducer);
  const korwil = useSelector((state) => state.korwilReducer);
  const storeClient = useSelector((state) => state.clientReducer);
  const [listClient, setListClient] = React.useState([]);
  const [idClient, setIdClient] = React.useState("");
  const [tanggal, setTanggal] = React.useState("");
  const [listKorwil, setListKorwil] = React.useState([]);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [filterClient, setFilterClient] = React.useState(null);
  const [statusOmit, setStatusOmit] = React.useState(true);
  const [inputDisable, setInputDisable] = React.useState(true);
  // const [currentPage, setCurrentPage] = React.useState(1);
  // const itemsPerPage = 10;

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  // };

  const options =
    auth.role === "super admin"
      ? [{ value: "", label: "All" }, ...listClient]
      : listClient;

  const handleFilterChange = (selectedOption) => {
    setIdClient(selectedOption.value);
    setFilterClient(selectedOption);
    setInputDisable(false);
    getAllKorwil(dispatch, { idClient: selectedOption.value });
  };

  const submitTargetKorwil = () => {
    setStatusOmit(false);
    if (tanggal === "" || idClient === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Harap lengkapi tanggal dan Pilih BPD",
      });
    } else {
      let successCount = 0;
      let errorCount = 0;
      const totalTargets = listKorwil.length;
      listKorwil.forEach((val, index) => {
        setTimeout(function () {
          tambahTargetKorwil({
            tanggal: tanggal,
            nominal: val.nominal,
            idKoordinatorWilayah: val._id,
            idClient: idClient,
          }).then((response) => {
            let array = [...listKorwil];
            if (response.data.status === 200) {
              array[index].status = "berhasil";
              successCount++;
            } else {
              array[index].status = "gagal";
              errorCount++;
            }
            setListKorwil(array);
            if (index === totalTargets - 1) {
              if (successCount === totalTargets) {
                Swal.fire({
                  icon: "success",
                  title: "Sukses",
                  text: "Semua target berhasil di set.",
                }).then(() => {
                  dispatch({
                    type: "SET_STATUS_INPUT_TARGET_KORWIL",
                    data: true,
                  });
                });
              } else if (errorCount === totalTargets) {
                Swal.fire({
                  icon: "error",
                  title: "Gagal",
                  text: "Semua target gagal di set.",
                }).then(() => {
                  dispatch({
                    type: "SET_STATUS_INPUT_TARGET_KORWIL",
                    data: true,
                  });
                });
              } else {
                Swal.fire({
                  icon: "warning",
                  title: "Peringatan",
                  text: "Beberapa target berhasil di set, namun ada yang gagal.",
                }).then(() => {
                  dispatch({
                    type: "SET_STATUS_INPUT_TARGET_KORWIL",
                    data: true,
                  });
                });
              }
            }
          });
        }, 1000 * index);
      });
    }
  };

  React.useEffect(() => {
    let tmp =
      korwil.listKorwil &&
      korwil.listKorwil.map((val) => {
        return {
          ...val,
          nominal: 0,
          status: null,
          action: (
            <>
              {" "}
              <Button
                className="mr-0"
                variant="info"
                style={{ marginTop: 5 }}
                onClick={() => setModalEdit(!modalEdit)}
              >
                Edit
              </Button>
            </>
          ),
        };
      });
    setListKorwil(tmp);
  }, [korwil.listKorwil]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });

    setListClient(tmp);
  }, [storeClient.listClient]);

  const handleClick = () => {
    dispatch({ type: "SET_STATUS_INPUT_TARGET_KORWIL", data: true });
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f1f5f9", // Abu-abu biru muda yang sangat clean
        minHeight: "55px",
        borderTop: "1px solid #e2e8f0",
        borderBottom: "2px solid #e2e8f0",
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        fontWeight: "800",
        textTransform: "uppercase",
        color: "#475569",
        letterSpacing: "0.5px",
      },
    },
    rows: {
      style: {
        minHeight: "65px", // Dipertinggi sedikit agar CurrencyInput tidak sesak
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #f1f5f9",
        },
        "&:hover": {
          backgroundColor: "#f8fafc",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
      },
    },
  };
  const colTargetKorwil = [
    {
      name: "NO",
      width: "70px",
      center: true,
      cell: (row, index) => (
        <span className="fw-800 text-muted" style={{ fontSize: "13px" }}>
          {index + 1}
        </span>
      ),
    },
    {
      name: "NO KARYAWAN",
      minWidth: "180px",
      center: true,
      cell: (row) => <span className="fw-800 text-dark">{row.nopeg}</span>,
    },
    {
      name: "NAMA KORWIL",
      minWidth: "250px",
      center: false, // Nama rata kiri lebih elegan
      cell: (row) => (
        <div className="d-flex align-items-center">
          <div
            className="mr-2 d-flex align-items-center justify-content-center rounded-circle bg-light text-primary fw-800 shadow-sm"
            style={{
              width: "32px",
              height: "32px",
              fontSize: "11px",
              border: "1px solid #e2e8f0",
            }}
          >
            <i className="fas fa-user-tie"></i>
          </div>
          <span className="fw-900 text-dark">{row.nama}</span>
        </div>
      ),
    },
    {
      name: "NOMINAL TARGET",
      minWidth: "220px",
      center: true,
      cell: (row, index) => (
        <div className="w-100 px-2">
          <CurrencyInput
            className="form-control text-right fw-800"
            style={{
              height: "40px",
              borderRadius: "10px",
              backgroundColor: inputDisable ? "#f8fafc" : "#ffffff",
              border: "1.5px solid #e2e8f0",
              fontSize: "14px",
              color: "#0ea5e9",
            }}
            name="nominal"
            placeholder="Masukkan nominal"
            disabled={inputDisable}
            prefix="Rp "
            onValueChange={(value) => {
              setListKorwil([
                ...listKorwil.slice(0, index),
                { ...row, nominal: value },
                ...listKorwil.slice(index + 1),
              ]);
            }}
          />
        </div>
      ),
    },
    {
      name: "STATUS",
      minWidth: "150px",
      center: true,
      omit: statusOmit,
      cell: (row) => {
        if (row.status === null || row.status === "loading") {
          return (
            <div className="d-flex align-items-center text-info fw-700">
              <div
                className="spinner-border spinner-border-sm mr-2"
                role="status"
              ></div>
              <span style={{ fontSize: "12px" }}>PROSES...</span>
            </div>
          );
        }
        if (row.status === "berhasil") {
          return (
            <div
              className="rounded-pill px-3 py-1 d-flex align-items-center"
              style={{
                backgroundColor: "#dcfce7",
                color: "#15803d",
                fontWeight: "800",
                fontSize: "11px",
              }}
            >
              <i className="fas fa-check-circle mr-1"></i> BERHASIL
            </div>
          );
        }
        return (
          <div
            className="rounded-pill px-3 py-1 d-flex align-items-center"
            style={{
              backgroundColor: "#fee2e2",
              color: "#b91c1c",
              fontWeight: "800",
              fontSize: "11px",
            }}
          >
            <i className="fas fa-times-circle mr-1"></i> GAGAL
          </div>
        );
      },
    },
  ];

  React.useEffect(() => {
    getAllKorwil(dispatch, { idClient: "" });
    getAllClient(dispatch);
  }, []);

  return (
    <>
      <Container fluid className="pt-3">
        <Row>
          <Col md="12">
            <Card
              className="border-0 shadow-sm"
              style={{ borderRadius: "20px" }}
            >
              <Card.Header className="bg-transparent border-0 pt-4 px-4">
                <div className="d-flex align-items-center">
                  <div
                    className="mr-3 d-flex align-items-center justify-content-center"
                    style={{
                      width: "45px",
                      height: "45px",
                      backgroundColor: "#e0f2fe",
                      borderRadius: "12px",
                      color: "#0ea5e9",
                    }}
                  >
                    <i className="fas fa-bullseye fa-lg"></i>
                  </div>
                  <Card.Title
                    as="h3"
                    className="m-0"
                    style={{
                      color: "#1e293b",
                      textTransform: "uppercase",
                      fontWeight: "900",
                      fontSize: "1.2rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Set Target Koordinator Wilayah
                  </Card.Title>
                </div>
              </Card.Header>

              <Card.Body className="px-4 pb-4">
                {/* FILTER BOX DENGAN BACKGROUND SOFT */}
                <div
                  className="p-4 mb-4"
                  style={{
                    backgroundColor: "#f8fafc",
                    borderRadius: "16px",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <Row className="align-items-end">
                    <Col md="3" className="mb-3 mb-md-0">
                      <label className="small fw-800 text-muted text-uppercase mb-2 d-block ml-1">
                        <i className="far fa-calendar-alt mr-1"></i> Pilih
                        Periode
                      </label>
                      <Form.Control
                        className="border-0 shadow-sm"
                        style={{
                          height: "45px",
                          borderRadius: "10px",
                          fontWeight: "600",
                        }}
                        onChange={(e) => setTanggal(e.target.value + "-01")}
                        type="month"
                      />
                    </Col>

                    <Col md="4" className="mb-3 mb-md-0">
                      <label className="small fw-800 text-muted text-uppercase mb-2 d-block ml-1">
                        <i className="fas fa-building mr-1"></i> Pilih Client /
                        BPD
                      </label>
                      <Select
                        className="react-select primary shadow-sm"
                        classNamePrefix="react-select"
                        name="Pilih Client"
                        value={filterClient}
                        onChange={(selectedOption) =>
                          handleFilterChange(selectedOption)
                        }
                        options={options}
                        placeholder="Cari Client..."
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderRadius: "10px",
                            height: "45px",
                            border: "none",
                          }),
                        }}
                      />
                    </Col>

                    <Col md="5" className="d-flex justify-content-md-end gap-2">
                      <Button
                        className="btn-fill fw-800 px-4 mr-2"
                        variant="secondary"
                        style={{
                          borderRadius: "10px",
                          height: "45px",
                          backgroundColor: "#94a3b8",
                          border: 0,
                        }}
                        onClick={handleClick}
                      >
                        CANCEL
                      </Button>
                      <Button
                        className="btn-fill fw-800 px-4 shadow-sm"
                        variant="success"
                        style={{
                          borderRadius: "10px",
                          height: "45px",
                          backgroundColor: "#0ea5e9", // Kita seragamkan dengan biru oceanic
                          border: 0,
                        }}
                        onClick={submitTargetKorwil}
                      >
                        <i className="fas fa-check-circle mr-2"></i>
                        SUBMIT TARGET
                      </Button>
                    </Col>
                  </Row>
                </div>

                {/* TABLE SECTION */}
                <div className="table-responsive rounded-xl shadow-sm border">
                  <DataTable
                    columns={colTargetKorwil}
                    data={listKorwil}
                    customStyles={{
                      ...customStyles,
                      headRow: {
                        style: {
                          backgroundColor: "#f1f5f9",
                          fontWeight: "800",
                          color: "#475569",
                        },
                      },
                    }}
                    pagination
                    highlightOnHover
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <style>{`
    .fw-800 { font-weight: 800; }
    .rounded-xl { border-radius: 12px; overflow: hidden; }
    .gap-2 { gap: 10px; }
    
    /* Perbaikan agar Input Month terlihat rapi di semua browser */
    input[type="month"]::-webkit-calendar-picker-indicator {
      cursor: pointer;
      opacity: 0.6;
    }
    input[type="month"]::-webkit-calendar-picker-indicator:hover {
      opacity: 1;
    }

    @media (max-width: 768px) {
      .btn-fill { width: 100%; margin-bottom: 10px; }
      .justify-content-md-end { flex-direction: column; }
    }
  `}</style>
      </Container>
    </>
  );
}

export default InputTargetKorwil;
